// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YLf4","actionIcon":"_3ARW3","waveContainer":"jKan0","wave":"_34l92","duration":"_7Pae9"};